<style lang="scss">
  @import '../resources/scss/about_digitalgrow.scss';
</style>

<script lang="ts">
  import type DigitalGrow from '../api/rest/directus-cms/about/models/DigitalGrow'
  import Metric from './Metric.svelte'
  import Pin from './svgs/Pin.svelte'

  export let digitalGrow: DigitalGrow
</script>

<section id="projects-world">
  {#if digitalGrow}
    <div class="container-fluid bg-white py-section">
      <div class="container-xxl">
        <div class="row">
          <div class="col-12 col-lg-5">
            <h1 class="text-primary pb-4">{digitalGrow.title}</h1>
            <div class="row pin-container pt-5 mb-4 mb-lg-0">
              {#each digitalGrow.projects as project}
                <div class="col-auto">
                  <div class="pin">
                    <Pin color={project.color} />
                    <div class="pin-inner-container text-white">
                      <h5 class="text-center">{project.name}</h5>
                      <div class="body-2">{project.since}</div>
                    </div>
                  </div>
                </div>
              {/each}
            </div>
          </div>
          <div class="col-12 col-lg-7 text-center">
            <img class="img-fluid" src={digitalGrow.map_image?.fullUrl} alt="map" />
          </div>
        </div>
        <div class="row py-4">
          <div class="col-12 col-sm-6 pt-4">
            <h3 class="text-primary">{digitalGrow.formation_title}</h3>
            <div class="row metric-container pt-4 gy-5">
              {#each digitalGrow.formation_metrics as metric}
                <div class="col-12 col-sm-6">
                  <Metric
                    description={metric.name}
                    value={metric.value}
                    unit={metric.unit}
                    valueClass="text-neutral-b"
                    descriptionClass="text-neutral-b"
                  />
                </div>
              {/each}
            </div>
          </div>
          <div class="col-12 col-sm-6 pt-4">
            <h3 class="text-primary">{digitalGrow.assistance_title}</h3>
            <div class="row metric-container pt-4 gy-5">
              {#each digitalGrow.assistance_metrics as metric}
                <div class="col-12 col-sm-6">
                  <Metric
                    description={metric.name}
                    value={metric.value}
                    unit={metric.unit}
                    valueClass="text-neutral-b"
                    descriptionClass="text-neutral-b"
                  />
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</section>
